import { Injectable,isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { AppComponent } from '../app.component';


const API_WINKELS_ENDPOINT = '/product';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  

  constructor(private http: HttpClient) { }
  getProducts(): Observable<any> {
    return this.http.get(AppComponent.baseUrl+ API_WINKELS_ENDPOINT+ '/overview', { responseType: 'text' });
    }
    addProduct(postData): Observable<any> {
      return this.http.post(AppComponent.baseUrl+ API_WINKELS_ENDPOINT+'/add-product', postData, { responseType: 'text' });
      }
      getProduct(id): Observable<any> {
        return this.http.get(AppComponent.baseUrl+ API_WINKELS_ENDPOINT+ '/get-product?id='+id, { responseType: 'text' });
        }
        deleteProduct(id): Observable<any> {
          return this.http.get(AppComponent.baseUrl+ API_WINKELS_ENDPOINT+ '/remove-product?id='+id, { responseType: 'text' });
          }
          updateProduct(id,category_id): Observable<any> {
            return this.http.get(AppComponent.baseUrl+ API_WINKELS_ENDPOINT+ '/update-product?id='+id+"&category_id="+category_id, { responseType: 'text' });
            }
}
